<template>
  <div>
  
    
  <b-row >
       
    <!----- SideBar All Design List ---->
     <div class="managebrandside">
       <sidebarSettingsComponent></sidebarSettingsComponent>
     </div>
    <!----- SideBar All Design List End ----> 

     <div class="design-container-details__main">
        <b-row class="col-md-12 managebrandsidebar">
          <b-col md="12" >
            <!-- <div class="pull-right"> -->
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret >
            <template v-slot:button-content>
             <!--  <span class="cui-options icons font-1xl d-block" style="font-size: 20px;"></span> -->
              <i class="fa fa-sliders" aria-hidden="true" style="font-size:20px"></i>
            </template>
            <b-dropdown-item style="font-size: 16px;"> 
            <div>
               <router-link to="/updateProfile" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Collections" style="padding-left:30px;"> 
          <i class="fa fa-pencil"></i>&nbsp;&nbsp;&nbsp; 
        <span>Profile</span>

        </router-link>
            </div>
            <div v-if="this.user_type=='Admin' || this.user_type=='Brand_Manager' || this.user_type=='Quality_Head' || this.user_type=='Quality_Controller'" >
        <router-link to="/usersdetails" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Collections" style="padding-left:30px;"> 
          <i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp; 
        <span>Manage Users</span>

        </router-link>
        
      </div>
      <div v-if="this.user_type=='Brand_Manager' || this.user_type=='Quality_Head'">
        <router-link to="/mybranddetails" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Collections" style="padding-left:30px;"> 
          <i class="fa fa-shopping-cart" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp; 
        <span>My Brands</span>

        </router-link>
        
      </div>
      <div  style="display:none">
        <router-link to="/updateProfile" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Coll ections" style="padding-left:30px;"> 
          <i class="fa fa-users"></i>&nbsp;&nbsp;&nbsp; 
        <span>Manage Vendors</span>

        </router-link>
      </div>
      <div v-if="this.user_type=='Admin'">
        <router-link to="/manage_brands" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Coll ections" style="padding-left:30px;"> 
          <i class="fa fa-users"></i>&nbsp;&nbsp;&nbsp; 
        <span>Manage Brands</span>

        </router-link>
        
      </div>
        <div v-if="this.user_type=='Admin'">
        <router-link to="/marginmaster" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Coll ections" style="padding-left:30px;"> 
          <i class="fa fa-pie-chart" aria-hidden="true"></i>


        &nbsp;&nbsp;&nbsp; 
        <span>Manage Margin Master</span>

        </router-link>
        
      </div>

            </b-dropdown-item>
            
          

           

          </b-dropdown>
        <!-- </div> -->
          </b-col>
        </b-row>
      <div class="col-md-12 ">


            <!-- code for table -->
             
               <!-- nmmmmmmmmnm {{ this.user_type }} -->
                <b-col md="12" v-if="this.user_type=='Admin'">
                  <b-card-body>
                    <div class="col-md-6 pull-left"> <h3>Brands</h3>
                    </div>
                  
                    <b-table show-empty stacked="md" :busy="isBusy"  :items="items"  :fields="fields"  :current-page="currentPage" :bordered="bordered"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered" >
                      <template slot="sr_no" slot-scope="row">
                          {{firstIndex+1}}
                        </template>
                  
                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>

                    <template slot="action" slot-scope="row">
                        <b-col md="12" >
                          <button @click="managebrandfunction(row.item); getbrandmanagerlist(row.item)"><i class="fa fa-plus" variant="primary" aria-hidden="true" style="color: green; margin-left: 5px; background-color: none" >&nbsp;</i>Assign New BM</button>

                        </b-col><br>
                        <b-col md="12" >
                          <button @click="manageqcfunction(row.item);getAllocatedQualityControllerList(row.item)"><i class="fa fa-plus" variant="primary" aria-hidden="true" style="color: green; margin-left: 5px; background-color: none" >&nbsp;</i>Assign New QC</button>
                        </b-col>
                    </template> 
                    
          
                  </b-table>
                  </b-card-body>
                </b-col > 

                <!-- Table for QC -->
                  <b-col md="12" v-if="this.user_type=='Quality_Controller'">
                  <b-card-body>
                    <div class="col-md-6 pull-left" style="font-size:15px;"> <h3>QC</h3>
                    </div>
                  
                    <b-table show-empty stacked="md" :busy="isBusy"  :items="items"  :fields="fields"  :current-page="currentPage" :bordered="bordered"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered" >
                      <template slot="sr_no" slot-scope="row">
                          {{firstIndex+1}}
                        </template>
                  
                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>

                    <template slot="action" slot-scope="row">
                        <b-col md="12" class="pull-right text-right">
                          <button @click="manageqcexecutivefunction(row.item); getbrandmanagerlist(row.item)"><i class="fa fa-plus" variant="primary" aria-hidden="true" style="color: green; margin-left: 5px; background-color: none" >&nbsp;</i>Assign New QC Executive</button>
                        </b-col>
                    </template> 
          
                  </b-table>
                  </b-card-body>
                </b-col >

                <!-- Code Manage Brand Manager -->
            <b-modal id="managebrandmanagermodel" size="md" title="Add Brand Manager" v-model="managebrandmanagermodel" @ok="managebrandmanagermodel = false">
                <form >
                  <div  class='col-md-12' > 
                            <label for="name">Select Brand Manager</label>

                            <select class="form-control" id="selected_brand_manager" name="selected_brand_manager" v-validate="'required|'" v-model="selected_brand_manager">
                                <option value=selected>Select Brand Manager</option>
                                <option v-for="list in brand_manager_list" :value="list.user_id">
                                    {{ list.full_name }}&nbsp; &nbsp; {{list.designation}} 
                                </option>

                            </select> 

                          </div>

                    <label for="name">Select Sub Category</label><br>
                    <input type='checkbox' @click='checkAll()' v-model='isCheckAll'> Check All
                    <div id='myapp' class="col-md-12" style="height: 200px;overflow-y: scroll;"><br>
                      
                      
                      <table class="table col-md-12" id="myTable" >
                        <thead>
                          <tr>
                            <td scope="col">Sub Cat ID</td>
                            <td scope="col">Subcategory Name</td>
                            <!-- <td scope="col">Email ID</td>
                            <td scope="col">City</td>
                            <td scope="col">Address</td> -->
                          </tr>
                        </thead>
                        <tbody >
                      <tr v-for='opt in sub_cat_arr'>
                        <td>
                         <input type='checkbox' v-bind:value='opt.sub_catid' v-model='selected_sub_cat' @change='updateCheckall()' required="selected_sub_cat">&nbsp;{{ opt.sub_catid }}
                        </td>
                        <td>{{ opt.sub_cattitle }}</td>
                      </tr>
                      </tbody>
                      <!-- <tbody v-if="vendor_msg=='Unsuccessful'"> 
                        <tr>
                          <td colspan="3" style="text-align: center;">No Records Found</td>
                        </tr>
                      </tbody> -->

                      </table>
                   

                    </div>
                      <div class="col-md-12 mb-4 text-center" >
                          <button type='button'   @click="adduser();"  class="btn btn-success submit_btn invoice-save-bottom"  style="float: right;">
                              <i class="fa fa-save"></i>
                              Assign Brand Manager
                          </button>
                      </div>    
                </form>  
            </b-modal>

                <!-- Code For Manage Brand Manager Ends -->

                <!-- Code Manage QC  -->
            <b-modal id="managequalitycontrollermodel" size="md" title="Add Quality Controller" v-model="managequalitycontrollermodel" @ok="managequalitycontrollermodel = false">
                <form >
                  <div  class='col-md-12' > 
                            <label for="name">Select Quality Controller11</label>
                    <!-- {{ qc_list }} -->
                            <select class="form-control" style="margin-bottom: 10px" id="selected_qc" name="selected_qc" v-validate="'required|'" v-model="selected_qc">
                              
                                <option value=selected>Select Quality Controller</option>
                                <option v-for="list in qc_list" :value="list.user_id">
                                    {{ list.full_name }}&nbsp; &nbsp; {{list.designation}} 
                                </option>

                            </select> 

                          </div>
                      <div class="col-md-12 mb-4 text-center" >
                          <button type='button'   @click="addqcuser();"  class="btn btn-success submit_btn invoice-save-bottom"  style="float: right;">
                              <i class="fa fa-save"></i>
                              Assign QC Executive
                          </button>
                      </div>    
                </form>  
            </b-modal>

                <!-- Code For Manage QC Ends -->


                <!-- Code Manage QC Executive -->
            <b-modal id="manageqcexecutivemodel" size="md" title="Add QC Exexutive" v-model="manageqcexecutivemodel" @ok="manageqcexecutivemodel = false">
                <form >
                  <div  class='col-md-12' > 
                            <label for="name">Select QC Executive</label>

                            <select class="form-control" style="margin-bottom: 10px" id="selected_brand_manager" name="selected_brand_manager" v-validate="'required|'" v-model="selected_brand_manager">
                                <option value=selected>Select Brand Manager</option>
                                <option v-for="list in brand_manager_list" :value="list.user_id">
                                    {{ list.full_name }}&nbsp; &nbsp; {{list.designation}} 
                                </option>

                            </select> 

                          </div>
                      <div class="col-md-12 mb-4 text-center" >
                          <button type='button'   @click="addqcuser();"  class="btn btn-success submit_btn invoice-save-bottom"  style="float: right;">
                              <i class="fa fa-save"></i>
                              Assign QC Executive
                          </button>
                      </div>    
                </form>  
            </b-modal>

                <!-- Code For Manage QC Executive Ends -->

      </div>
    </div>
 </b-row>
</div>
</template>                


<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
import sidebarSettingsComponent from './_sidebarSettingsComponent.vue'
const axios = require('axios');
export default {
  components: {
    sidebarSettingsComponent
  },
  data: function() {
    return {
      isBusy: false,  
      bordered: true,
      showSideMenu:true,
      sortDesc: true,
      sortDirection: 'desc',
      currentPage: 1,
      firstIndex: 0,
      sortBy: null,
      filter: null,
      items:[],
       fields: [
          // { key: 'sr_no', label: 'Sr No.', sortable: true, sortDirection: 'desc' },
          { key: 'brand_title', label: 'Brand Title', sortable: true, tdClass: 'titlebrand'},
          { key: 'brand_id', label: 'Brand ID', sortable: true, tdClass: 'brandid'},
          { key: 'abvr', label: 'Abbreviation', sortable: true, tdClass: 'abbrbrand'},
          { key: 'assigned_brand_manager', label: 'Assigned Brand Manager', sortable: true, tdClass: 'assignedbrand'},
          { key: 'assigned_quality_controller', label: 'Assigned Quality Controller', sortable: true, tdClass: 'assignedbrand'},
          { key: 'action', label: 'Action', sortable: true, tdClass: 'actionbrand'}
        ],
        managebrandmanagermodel: false,
        manageqcexecutivemodel:false,
        selected_brand_id: 0,
        temp_brand_id: 0,
        brand_manager_list: [],
        selected_brand_manager: [],
        selected_qc: [],
        selected: '',
        sub_cat_arr: [],
        selectedsubcat: [],
        isCheckAll: false,
        selectedsubcat_length: 0,
        selected_sub_cat: [],
        user_type:'',
        managequalitycontrollermodel: false,
        qc_list:[],
        selected_brand_type:'',
        route_id:'',
        route_status:''
        
    };
  },
  created: function() {
    this.getbranddetails();
    // this.assignNewBrandManager();
    this.getSubCategoryList();
    var userData = localStorage.getItem('userData')
    if (userData) 
    {
      var userInfo = JSON.parse(userData)
      this.user_type = userInfo[0].user_type;
      console.log("User_Type",this.user_type);
      
    }

    this.route_id=this.$route.params.id;
    const myArr = this.route_id.split(",");
     // const mysubcatArr = this.route_id;
     console.log("Myarr",myArr);
     this.route_status=myArr[0];
     console.log("HHHHHH",this.route_status);
    //  this.selected_brand_id=myArr[1];
     this.selected_brand_type = myArr[2];

   
  },

  methods: {
      reloadPage(){
      window.location.reload()
      },

      //Code For Select SubCat
      checkAll: function(){
                this.isCheckAll = !this.isCheckAll;
                this.selected_sub_cat = [];
                if(this.isCheckAll){ // Check all
                  for (var key in this.sub_cat_arr) {
                    this.selected_sub_cat.push(this.sub_cat_arr[key]);
                    this.selectedsubcat_length = this.selected_sub_cat.length
                  }
                }
              
          },
          updateCheckall: function(){
            if(this.selected_sub_cat.length>0){
            if(this.selected_sub_cat.length == this.sub_cat_arr.length){
               this.isCheckAll = true;
               this.selectedsubcat_length = this.selected_sub_cat.length;
                    
            }else{
               this.isCheckAll = false;
               this.selectedsubcat_length = this.selected_sub_cat.length;
                    
            }
          }
          else{
            // alert("Please Select Atleast Sub Category");
             this.$fire({
                 text:"Please Select Atleast Sub Category.",
                 type: "warning",
                 timer: 30000
                        })
            document.getElementById("overlay").style.display = "none";
          }
          },

      //Code For Select SubCat Ends

          /******Function To Get Sub Category List********/
      getSubCategoryList: function() {    
       
      axios.post(`${CONSTANTS.API_URL}/getSubCategoryList`,{})
      .then(response => {
        //document.getElementById("overlay").style.display = "none";
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          this.sub_cat_arr  = this.result.returnvalue;
          this.totalRows = this.result.returnvalue.length;
          
          
        }else {
         this.sub_cat_arr =[];
         this.totalRows=0;
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    },
    /******Code For SubCategory Ends*********/


      //Code For Assign Brand Manager 
      //Code For Get Brand Manager List
      getbrandmanagerlist: function(value){
        this.temp_brand_id= value.brand_id;
         this.isBusy = true;  
         const Obj ={
           brand_id: this.temp_brand_id
         }  
        axios.post(`${CONSTANTS.API_URL}/getAllocatedBrandManagersList`,Obj)
        .then(response => {
          // document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === 'Successful') {
            this.brand_manager_list = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
            
          }else {
           this.brand_manager_list =[];
           this.totalRows=0;
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      },
       //Code For Get QC Manager List Ends

       //Code For Get QC List
      getAllocatedQualityControllerList: function(value){
        this.temp_brand_id= value.brand_id;
         this.isBusy = true;  
         const Obj ={
           brand_id: this.temp_brand_id
         }  
        axios.post(`${CONSTANTS.API_URL}/getAllocatedQualityControllerList`,Obj)
        .then(response => {
          // document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === 'Successful') {
            this.qc_list = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
            
          }else {
           this.brand_manager_list =[];
           this.totalRows=0;
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      },
       //Code For Get QC List Ends

      manageqcexecutivefunction: function(value){
        // this.selected_brand_id= value.brand_id;
        this.manageqcexecutivemodel= !this.manageqcexecutivemodel;
      },
      //Code For Get Brand Manager List Ends

      managebrandfunction: function(value){
        this.selected_brand_id= value.brand_id;
        this.managebrandmanagermodel= !this.managebrandmanagermodel;
      },
      manageqcfunction: function(value){
        this.selected_brand_id= value.brand_id;
        this.managequalitycontrollermodel= !this.managequalitycontrollermodel;
      },
      //Assign New Brand Manager

      //Assign New Brand Manager Ends 
      adduser: function(){
        var userData = localStorage.getItem('userData');

         var userInfo = JSON.parse(userData)
         this.isBusy = true;  
         var assign_subcat_id = [];
          assign_subcat_id.push(this.buyer_id);
         const Obj ={
          brands: this.selected_brand_id,
          created_by: userInfo[0].email_id,
          brand_manager: this.selected_brand_manager, 
          sub_catid: this.selected_sub_cat
         }   
        axios.post(`${CONSTANTS.API_URL}/assignNewBrandManager`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            // alert("Brand Manager Assigned Successfully");
            this.$fire({
                 text:"Brand Manager Assigned Successfully.",
                 type: "success",
                 timer: 30000
                        })
            this.managebrandmanagermodel= false;
            this.isBusy = !this.isBusy;
            this.getbranddetails();
            // this.items  = this.result.returnvalue;
            // this.totalRows = this.result.returnvalue.length;
            
            
          }else {
           this.items =[];
           this.totalRows=0;
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      },

      //Assign New Brand Manager Ends 

      //Assign New QC
      addqcuser: function(){
        var userData = localStorage.getItem('userData');

         var userInfo = JSON.parse(userData)
         this.isBusy = true;  
         var assign_subcat_id = [];
          assign_subcat_id.push(this.buyer_id);
         const Obj ={
          brands: this.selected_brand_id,
          created_by: userInfo[0].email_id,
          user_id: this.selected_qc, 
         }  
        axios.post(`${CONSTANTS.API_URL}/assignNewQualityController`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            // alert("Brand Manager Assigned Successfully");
            this.$fire({
                 text:"Quality Controller Assigned Successfully.",
                 type: "success",
                 timer: 30000
                        })
            this.managequalitycontrollermodel= false;
            this.isBusy = !this.isBusy;
            this.getbranddetails();
            // this.items  = this.result.returnvalue;
            // this.totalRows = this.result.returnvalue.length;
            
            
          }else {
           this.items =[];
           this.totalRows=0;
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      },
      //Assign New QC Ends

      getbranddetails: function() {
        // document.getElementById("overlay").style.display = "block";
        this.isBusy = true;    
        const obj ={
          brand_type:this.selected_brand_type
        }  
        axios.post(`${CONSTANTS.API_URL}/brandlisting`,obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            this.items  = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
            
          }else {
           this.items =[];
           this.totalRows=0;
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })


  
    },
    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
  
  }
};
</script>
<style>
  .assignedbrand{
    width: 70px !important;
    word-wrap: break-word; 
    column-width: fixed;
  }
  .actionbrand{
    width: 180px;
    word-wrap: break-word; 
    column-width: fixed;
  }
  .titlebrand{
    width: 50px;
    word-wrap: break-word; 
    column-width: fixed;
  }
  .abbrbrand{
    width: 40px !important;
    word-wrap: break-word; 
    column-width: fixed;
  }
  .brandid{
    width: 70px;
    word-wrap: break-word; 
    column-width: fixed;
  }
  @media (max-width: 1040px)
{
 .managebrandside{
  display:none;
 }
}
@media (min-width: 1040px)
{
 .managebrandsidebar{
  display:none;
 }
}
@media (max-width: 766px)
{
.titlebrand,.brandid,.abbrbrand,.assignedbrand,.actionbrand{
    width: 100% !important;
    word-wrap: break-word; 
    
  }
  
}
</style>


